"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOptional = exports.optional = exports.isMulti = exports.multi = exports.isNamed = exports.named = exports.getDependencies = exports.withDependencies = void 0;
const symbols_1 = require("./symbols");
const withDependencies = (dependencies, target) => {
    return Object.assign(target.bind(null), { [symbols_1.ModuleMetadataSymbol]: { dependencies } });
};
exports.withDependencies = withDependencies;
const getDependencies = (target) => target[symbols_1.ModuleMetadataSymbol].dependencies;
exports.getDependencies = getDependencies;
const named = (identifier, name) => ({
    name: name,
    identifier,
});
exports.named = named;
const isNamed = (identifier) => !!(identifier.name && identifier.identifier);
exports.isNamed = isNamed;
const multi = (identifier) => ({
    identifier,
    multi: true,
});
exports.multi = multi;
const isMulti = (identifier) => !!(identifier.multi && identifier.identifier);
exports.isMulti = isMulti;
const optional = (identifier) => ({
    identifier,
    optional: true,
});
exports.optional = optional;
const isOptional = (identifier) => !!(identifier.optional && identifier.identifier);
exports.isOptional = isOptional;
//# sourceMappingURL=metadata.js.map